import { IconColor } from './iconsInterface'

export default function StopIcon({ color }: IconColor): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200">
      <path
        d="M1089.27 252.99c-70.89-98.99-170.01-175-284.28-216.98C687.16-7.24 555.3-11.5 434.65 23.1c-115.56 33.04-220.62 101.68-296.9 194.57C59.04 313.4 11.41 430.96 1.77 554.49c-9.64 124.09 20.42 250.74 85.21 357.1 62.24 102.25 155.4 185.64 264.43 234.85 115.42 52.05 245.01 66.65 369.07 41.69 118.96-23.97 229.69-85.8 313.35-173.59 83.66-87.64 140.38-200.53 158.66-320.37 4.82-31.06 7.37-62.4 7.51-93.88v-.14c-.28-123.67-38.71-246.48-110.74-347.17v.02zM877.58 837.14c-.14 21.84-15.31 39.43-37.43 40.56h-473c-13.33 0-26.09-2.41-35.45-13.33-8.37-9.64-9.36-20.85-9.36-32.76V372.98c0-7.09-.57-14.75 1.28-21.7 4.82-19 22.12-28.79 40.55-28.79h456.27 18.43c21.98.43 38.28 17.44 38.71 39.14.43 21.56 0 43.25 0 64.81v410.7h0z"
        fill={color}
      />
    </svg>
  )
}
